/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplatesControllerImportFromExcelMutationResponse, TemplatesControllerImportFromExcel400, TemplatesControllerImportFromExcel401, TemplatesControllerImportFromExcel403 } from "../../models/checklistsController/TemplatesControllerImportFromExcel";

function getTemplatesControllerImportFromExcelUrl() {
  const res = { method: 'POST', url: `/api/v1/checklist-templates/import-excel` as const }  
  return res
}

/**
 * @description Imports a multi-tab Excel file to create a new template, update an existing DRAFT, or create a new version of a PUBLISHED template.
 * @summary Import checklist template from Excel
 * {@link /api/v1/checklist-templates/import-excel}
 */
export async function templatesControllerImportFromExcel(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplatesControllerImportFromExcelMutationResponse, ResponseErrorConfig<TemplatesControllerImportFromExcel400 | TemplatesControllerImportFromExcel401 | TemplatesControllerImportFromExcel403>, unknown>({ method : "POST", url : getTemplatesControllerImportFromExcelUrl().url.toString(), ... requestConfig })  
  return res.data
}